import BaseComponent from 'scripts/BaseComponent.js';

export default class ProductCustomizerCardForm extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      cardBtn: '.js-cardBtn',
      cardMessageArea: '.js-cardMessageTextarea',
      cardStyleInput: '.js-cardStyleInput',
      cardMessageInput: '.js-cardMessageInput',
      quickAdd: '.js-quickAdd',
    };

    this.dom = {
      $component: component,
      $cardBtns: this.$getAll(this.refs.cardBtn),
      $cardMessageArea: this.$get(this.refs.cardMessageArea),
      $cardStyleInput: document.querySelector(this.refs.cardStyleInput),
      $cardMessageInput: document.querySelector(this.refs.cardMessageInput),
      $quickAdd: this.$get(this.refs.quickAdd),
    };

    this.state = {
      selectedCardClass: 'selected-card',
      showMessageInputClass: 'show-message-input',
      selectedCardStyle: '',
      quickAddEvent: 'quickadd',
    };

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();

    this.setClickWithElement(dom.$cardBtns, this.selectCard);
    this.setClick(dom.$quickAdd, this.quickAdd);

    if (dom.$cardBtns.length === 1) {
      this.selectCard(dom.$cardBtns[0]);
    }
  }

  selectCard(btn) {
    const { dom, state, refs } = this;
    const { cardStyle } = btn.dataset;
    const cardMessage = dom.$cardMessageArea.value;

    if (cardStyle === state.selectedCardStyle) return;

    if (state.selectedCardStyle) {
      this.$get(`${refs.cardBtn}[data-card-style="${state.selectedCardStyle}"]`)
        .classList.remove(state.selectedCardClass);
    }

    state.selectedCardStyle = cardStyle;
    btn.classList.add(state.selectedCardClass);
    dom.$component.classList.add(state.showMessageInputClass);
    dom.$cardStyleInput.value = cardStyle;
    dom.$cardMessageInput.value = cardMessage;
  }

  quickAdd() {
    const { dom, state } = this;
    dom.$cardMessageArea.value = '';
    dom.$cardStyleInput.value = '';

    document.dispatchEvent(new Event(state.quickAddEvent));
  }
}
